import React from 'react';
import useTheme from '../hooks/useTheme';

interface CardProps {
  children: React.ReactNode;
  hoverable?: boolean;
  style?: React.CSSProperties;
  onClick?: () => void;
  variant?: 'default' | 'primary' | 'secondary';
}

export const Card: React.FC<CardProps> = ({ children, hoverable = false, style = {}, onClick, variant = 'default' }) => {
  const { theme } = useTheme();

  const topBorderColor = variant === 'primary'
    ? theme.colors.primary
    : variant === 'secondary'
      ? theme.colors.secondary
      : theme.colors.border;

  const baseStyle: React.CSSProperties = {
    backgroundColor: theme.colors.surface,
    borderRadius: theme.borderRadius.r1,
    padding: '20px',
    border: `1px solid ${theme.colors.border}`,
    borderTop: `3px solid ${topBorderColor}`,
    boxShadow: theme.shadow.cardShadow,
    transition: 'all 0.3s ease',
    ...(onClick && { cursor: 'pointer' }),
    ...style,
  };

  return (
    <div
      style={baseStyle}
      onClick={onClick}
      onMouseEnter={(e) => {
        if (hoverable) {
          e.currentTarget.style.transform = 'translateY(-4px)';
          e.currentTarget.style.boxShadow = theme.shadow.hoverShadow;
          e.currentTarget.style.borderTopColor = variant === 'primary' ? theme.colors.secondary : theme.colors.primary;
        }
      }}
      onMouseLeave={(e) => {
        if (hoverable) {
          e.currentTarget.style.transform = '';
          e.currentTarget.style.boxShadow = theme.shadow.cardShadow;
          e.currentTarget.style.borderTopColor = topBorderColor;
        }
      }}
    >
      {children}
    </div>
  );
};

